type Roles = {
  level: number;
  id: string;
  name: string;
};

export const RolesList = [
  { level: 1, id: 'Collector', name: 'Motociclista' },
  { level: 2, id: 'Census', name: 'Censista' },
  { level: 3, id: 'StoreManager', name: 'Jefe de tienda' },
  { level: 4, id: 'ZoneManager', name: 'Gerente de Zona' },
  { level: 5, id: 'RegionManager', name: 'Gerente Regional' },
  { level: 6, id: 'Coordinator', name: 'Coordinador' },
  { level: 7, id: 'CommercialManager', name: 'Gerente Comercial' },
  { level: 8, id: 'HelpDesk', name: 'HelpDesk' },
  { level: 9, id: 'Admin', name: 'Administrador' },
  { level: 5, id: 'FinanceManager', name: 'Finanzas' },
];
